export default __webpack_public_path__ + "static/media/profile-pic.1baa380f.png";